import { render } from "./SaveAllDraftsButton.vue?vue&type=template&id=57b3bbf4&scoped=true&ts=true"
import script from "./SaveAllDraftsButton.vue?vue&type=script&lang=ts"
export * from "./SaveAllDraftsButton.vue?vue&type=script&lang=ts"

import "./SaveAllDraftsButton.vue?vue&type=style&index=0&id=57b3bbf4&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57b3bbf4"]])

export default __exports__